import React from 'react'

import { InstantQuoteQuestions } from '@flows-ui/components/InstantQuoteQuestions'
import type {
  AnyStepContentElement,
  InjectedStepContentRendererProps,
} from '@flows/core/types/stepContentTypes'

const PRODUCT_KEY = 'contents_v1_getsafe_de' as const

export const ContentsInstantQuoteQuestions = (
  props: InjectedStepContentRendererProps<AnyStepContentElement>
) => (
  <InstantQuoteQuestions
    {...props}
    productKey={PRODUCT_KEY}
    damagesTitleKey="sharedFlows_common:customComponents.contentsInstantQuoteQuestions.damages.title"
  />
)
